export enum QueryType {
    sql = 'sql',
}
